/*@ngInject*/
const FormReferencesRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.getFormReferences = function (uiFormTemplateId) {
        var url = '/rest/UIFormTemplate/' + uiFormTemplateId + '/findReferences';
        return this.get(url);
    };
};

angular.module('umCore')
    .service('formReferencesRepository', FormReferencesRepository);
